.wrapper {
	display: inline-flex;
	width: 100%;
}

.alignRight {
	justify-content: flex-end;
	text-align: right;
}

.readButton {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	border: 0;
	background: transparent;
	padding: 0;
	margin: 0;
	cursor: pointer;
	color: #2c3a4b;
	font: inherit;
}

.readButton.alignRight {
	justify-content: flex-end;
	width: 100%;
}

.readButton:disabled {
	cursor: not-allowed;
	opacity: 0.6;
}

.readText {
	white-space: nowrap;
}

.readIcon {
	width: 14px;
	height: 14px;
	color: #7fb02f;
}

.inlineEdit {
	display: flex;
	flex-direction: column;
	gap: 8px;
	width: min(260px, 100%);
}

.inlineEdit.alignRight {
	align-self: flex-end;
}

.actions {
	display: flex;
	justify-content: flex-end;
	gap: 8px;
}

.actionIcon {
	width: 14px;
	height: 14px;
}

.cancelButton,
.saveButton {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	border: 1px solid #c7cfdd;
	border-radius: 10px;
	padding: 6px 10px;
	font-size: 14px;
	line-height: 1;
	background: #ffffff;
	cursor: pointer;
}

.cancelButton {
	color: #4d5a6c;
}

.saveButton {
	background: #7fb02f;
	border-color: #7fb02f;
	color: #ffffff;
}

.cancelButton:disabled,
.saveButton:disabled {
	opacity: 0.65;
	cursor: not-allowed;
}

.errorText {
	font-size: 12px;
	color: #d63f3f;
}
